import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addPrompts } from '../../services/monitor/MonitorService';
import { MonitorQuestion } from '../../../models/monitor/MonitorQuestion';
import { GET_TAGS_KEYS } from '../../query/tags/keys';
import { GET_COMMON_KEYWORDS } from '../../query/keyword/keys';
import { GET_PROJECT_MONITORS } from '../../query/monitor/keys';

interface MonitorPromptParams {
  projectId: number;
  monitorQuestions: MonitorQuestion[];
}

export const usePutMonitorsForProject = (projectId: number) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync: addMonitorPrompts,
    data: searchVolume,
    isPending: isLoading,
    isError,
    error,
    reset,
  } = useMutation<boolean, Error, MonitorPromptParams>({
    mutationFn: ({ projectId, monitorQuestions }) => addPrompts(projectId, monitorQuestions),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_TAGS_KEYS, projectId], refetchType: 'active' });
      queryClient.invalidateQueries({
        queryKey: [GET_COMMON_KEYWORDS, projectId],
        refetchType: 'active',
      });
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_MONITORS, projectId],
        refetchType: 'active',
      });
    },
  });

  return {
    addMonitorPrompts,
    searchVolume,
    isLoading,
    isError,
    error,
    reset,
  };
};
